import { DeviceFormData, DeviceFormKey } from '@/components/view/pm/device-edit-dialog/all.type';
import index from './index.vue';

export default index;
export {
    DeviceFormData,
    DeviceFormKey
};